import globalAxios from '../axios';
import authAxios from './axios';

const AUTH_REQUEST = 'AUTH_REQUEST',
	AUTH_SUCCESS = 'AUTH_SUCCESS',
	AUTH_ERROR = 'AUTH_ERROR',
	AUTH_LOGOUT = 'AUTH_LOGOUT',
	USER_REQUEST = 'USER_REQUEST',
	STORE_REFERRER_CLIENT = 'STORE_REFERRER_CLIENT';

const state = {
	referrerClientURL: sessionStorage.getItem('referrerClientURL') || '',
	accessToken: localStorage.getItem('accessToken') || '',
	refreshToken: localStorage.getItem('refreshToken') || '',
	status: {},
	hasLoadedOnce: false
};

const getters = {
	isAuthenticated: state => !!state.accessToken,
	authStatus: state => state.status,
	accessToken: state => state.accessToken,
	refreshToken: state => state.refreshToken,
	refreshTokenJTI: state => state.refreshTokenDecoded && state.refreshTokenDecoded.jti,
	referrerClientURL: state => state.referrerClientURL ? (state.referrerClientURL + '&token='+ state.refreshToken) : null,
	appURL: (state, getters, rootState, rootGetters) =>  {
		return rootGetters.APP_URL + '?token='+ state.refreshToken;
	},
	appSettingsURL: (state, getters, rootState, rootGetters) =>  {
		return rootGetters.APP_URL + '?destination=/account&token='+ state.refreshToken;
	},
	addressURL: (state, getters, rootState, rootGetters) =>  {
		return rootGetters.BRAND.addressURL + '&token='+ state.refreshToken;
	},
	appContactsURL: (state, getters, rootState, rootGetters) =>  {
		return rootGetters.APP_URL + '?destination=/account/contacts&token='+ state.refreshToken;
	},
	tronDownloadURL: (state, getters, rootState, rootGetters) =>  {
		return rootGetters.TRON_DOWNLOAD_URL + '?token='+ state.refreshToken;
	}
};

function decodeToken(token){
	return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
}

const actions = {
	[AUTH_REQUEST]: ({ commit, dispatch }, token) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			authAxios({url: 'tokens', data: token, method: 'POST'})
				.then(response => {
					const accessToken = response.data.accessToken;
					localStorage.setItem('refreshToken', token.refreshToken);
					localStorage.setItem('accessToken', accessToken);
					//set api instance header with token
					globalAxios.defaults.headers.common['X-IS-AT'] = accessToken;

					commit(AUTH_SUCCESS, { accessToken: accessToken, refreshToken: token.refreshToken });
					dispatch(USER_REQUEST);
					resolve(response);
				})
				.catch(error => {
					commit(AUTH_ERROR, error);
					localStorage.removeItem('refreshToken');
					localStorage.removeItem('accessToken');
					reject(error);
				});
		});
	},
	[AUTH_LOGOUT]: ({ commit, dispatch }, refreshJTI) => {
		return new Promise((resolve, reject) => {
			if(refreshJTI) {
				return authAxios({url: '/me/security/tokens/' + refreshJTI, method: 'DELETE'})
					.then(() => {
						resolve();
					});
			} else {
				resolve();
			}
		})
		.then(() => {
			commit(AUTH_LOGOUT);
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('accessToken');
			delete globalAxios.defaults.headers.common['X-IS-AT'];
		});
	}
};

const mutations = {
	[AUTH_REQUEST]: (state) => {
		state.status = {
			loading: true
		};
	},
	[AUTH_SUCCESS]: (state, response) => {
		state.status = {
			success: true
		};
		state.accessToken = response.accessToken;
		state.refreshToken = response.refreshToken;
		state.refreshTokenDecoded = decodeToken(response.refreshToken);
		state.hasLoadedOnce = true;
	},
	[AUTH_ERROR]: (state) => {
		state.status = {
			error: true
		};
		state.hasLoadedOnce = true;
	},
	[STORE_REFERRER_CLIENT]: (state, client) => {
		sessionStorage.setItem('referrerClientURL', client);
		state.referrerClientURL = client;
	},
	[AUTH_LOGOUT]: (state) => {
		state.accessToken = '';
	}
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/modules/auth/store.js